module.exports = __webpack_public_path__ + "img/solution-02-child.db0afe88.jpg";